import { getLocale } from "../runtime";

const sv_campaignexpirestomorrow = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kampanjen slutar imorgon!`
};

const campaignexpirestomorrow = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_campaignexpirestomorrow(inputs)
	return "campaignExpiresTomorrow";
};

export { campaignexpirestomorrow as "campaignExpiresTomorrow" };